import $api from "@/service/index"
import * as types from './mutationTypes'
import utils from '@/utils';
import routeCount from '@/staticData/routeCount';

const actions = {
	//【加入单位】设置
	setCompanyStep({commit}, {step, companyName, company_id, type}){
		commit(types.SETCOMPANYSTEP, {step, companyName, company_id, type});
	},

	//【公共数据】获取和设置
	setCommonData({commit}, data){
		commit(types.SETCOMMONDATA, data);
	},

	//【待处理数】获取和设置
	setCountWaitToHeadle({commit}, param={fromName:"", toName:""}){
		let fromRouteName = param.fromName;
		let toRouteName = param.toName;
		// console.log(fromRouteName);
		// console.log(toRouteName);
		let toBelongGroup = (toRouteName && routeCount[toRouteName]) ? routeCount[toRouteName].belongGroup : "";
		let fromBelongGroup = (fromRouteName && routeCount[fromRouteName]) ? routeCount[fromRouteName].belongGroup  : "";
		//暂时注释掉判断以保证数据更新及时
		// if(toBelongGroup && fromBelongGroup !== toBelongGroup){
			$api.getCountWaitToHeadle(toBelongGroup).then((data)=>{
				commit(types.SETCOUNTWAITTOHEADER, data);
			});
		// }
	},
    //单位所有用户备选项设置
    setAllCompanyUserList ({commit}){
        $api.getGroupRelateUser().then(data=>{
            let list = data ? data : [];
            let res = [];
            for(let i = 0 ; i< list.length ; i++){
                res = [...res,...list[i].user];
                res = [...new Set(res)];
            }
            commit(types.SETCOMPANYUSERLIST,res);
        });
    },
    /**
	 * 获取地区备选项
     * @param commit
	 * @param {string} data 父级id
     */
	setGlobalAddressList ({commit},data){
		$api.getAddressList(data).then(res=>{
			commit(types.SETADDRESSLIST,{"index":data,"list":res});
		});
	},
};


export default actions;


// WEBPACK FOOTER //
// ./src/store/actions.js